import React from 'react';

export const YourABACard = ({ iconInfo, title, text, border, background }) => {
    return (
        <div className="your-ABA-card-wrapper" style={{ border, background }}>
            <div className="your-ABA-card-icon" style={{ background: iconInfo.background, padding: iconInfo.padding }}>
                {iconInfo.Icon}
            </div>

            <h4 className="your-ABA-card-title">{title}</h4>

            <p className="your-ABA-card-text">{text}</p>
        </div>
    );
};
